import { Component, HostListener } from '@angular/core';
import { PostService } from 'src/app/services/repositories/post.service';
import { Subscription } from 'rxjs';
import { GroupService } from 'src/app/services/repositories/group.service';
import { IResponse } from 'src/app/interfaces/IResponse';
import { SocialMediaService } from 'src/app/services/repositories/social-media.service';
import { UiStateService } from 'src/app/services/utilities/ui-state.service';
@Component({
  selector: 'app-google-stats',
  templateUrl: './google-stats.component.html',
  styleUrls: ['./google-stats.component.scss']
})
export class GoogleStatsComponent {
  data: any =[{"label": "pageInsights.google.numberOfPublications", "value":'--', "icon":"grid", "tooltip":"tooltip.google.numberOfPublications", "tooltipPosition": "tooltip-right"},
    {"label": "pageInsights.google.interactions", "value":'--', "icon":"click", "tooltip":"tooltip.google.interactions", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.clicksToTheWebsite", "value":'--', "icon":"globe-click", "tooltip":"tooltip.google.clicksToTheWebsite", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.calls", "value":'--', "icon":"calls", "tooltip":"tooltip.google.calls", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.itinerary", "value":'--', "icon":"map-question", "tooltip":"tooltip.google.itinerary", "tooltipPosition": "tooltip-left"},
    {"label": "pageInsights.google.bookings", "value":'--', "icon":"reservation", "tooltip":"tooltip.google.bookings", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.orders", "value":'--', "icon":"shopping-card", "tooltip":"tooltip.google.orders", "tooltipPosition": "tooltip-left"},
    {"label": "pageInsights.google.clicksOnTheMenu", "value":'--', "icon":"menu-click", "tooltip":"tooltip.google.clicksOnTheMenu", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.conversations", "value":'--', "icon":"chat", "tooltip":"tooltip.google.conversations", "tooltipPosition": "tooltip-left"},
    {"label": "pageInsights.google.googleMapsSearchDesktop", "value":'--', "icon":"grid", "tooltip":"tooltip.google.googleMapsSearchDesktop", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.googleMapsSearchMobile", "value":'--', "icon":"grid", "tooltip":"tooltip.google.googleMapsSearchMobile", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.googleSearchDesktop", "value":'--', "icon":"grid", "tooltip":"tooltip.google.googleSearchDesktop", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.googleSearchMobile", "value":'--', "icon":"grid", "tooltip":"tooltip.google.googleSearchMobile", "tooltipPosition": "tooltip-top"},
    {"label": "pageInsights.google.viewsEstablishmentProfile", "value":'--', "icon":"grid", "tooltip":"tooltip.google.viewsEstablishmentProfile", "tooltipPosition": "tooltip-top"},
  ];
  subscriptions: Subscription[] = [];
  socialMedias: any[] = [];
  period={startDate:new Date() , endDate:new Date()}
  googlePageIds:any[]=[]
  googlePageNames:any[]=[]
  generalInsightsLabels:string[]=[
    'pageInsights.google.numberOfPublications',
    'pageInsights.google.interactions',
    'pageInsights.google.clicksToTheWebsite',
    'pageInsights.google.calls',
    'pageInsights.google.itinerary',
  ]
  commercialEngagementInsightsLabels:string[]=[
    'pageInsights.google.bookings',
    'pageInsights.google.orders',
    'pageInsights.google.clicksOnTheMenu',
    'pageInsights.google.conversations',
  ]
  googleMapsSearchDesktop : any = {"label": "pageInsights.google.googleMapsSearchDesktop", "value":'--', "icon":"grid", "tooltip":"tooltip", "tooltipPosition": "tooltip-top"};
  googleMapsSearchMobile : any = {"label": "pageInsights.google.googleMapsSearchMobile", "value":'--', "icon":"grid", "tooltip":"tooltip", "tooltipPosition": "tooltip-top"};
  googleSearchDesktop : any = {"label": "pageInsights.google.googleSearchDesktop", "value":'--', "icon":"grid", "tooltip":"tooltip", "tooltipPosition": "tooltip-top"};
  googleSearchMobile : any = {"label": "pageInsights.google.googleSearchMobile", "value":'--', "icon":"grid", "tooltip":"tooltip", "tooltipPosition": "tooltip-top"};
  viewsEstablishmentProfile : any = {"label": "pageInsights.google.viewsEstablishmentProfile", "value":'--', "icon":"grid", "tooltip":"tooltip.google.viewsEstablishmentProfile", "tooltipPosition": "tooltip-top"};
  isInsightsLoading:boolean=true


  constructor(protected postService: PostService,
  private groupService: GroupService,
  private socialMediaService:SocialMediaService,
  private uiStateService:UiStateService
  ){}

  updateStats(dateValue:any = null){
    console.log("[google]  dateRange Update",dateValue,this.period);
    this.isInsightsLoading = true;

    if(!dateValue){
      dateValue = {
        startDate: new Date(),
        endDate: new Date()
      }
      dateValue.startDate.setFullYear(this.period.endDate.getFullYear() - 1);
    }
    else if(dateValue.hasOwnProperty('pageStatsstartDate')){
      dateValue.startDate = dateValue.pageStatsstartDate
      dateValue.endDate = dateValue.pageStatsendDate
    }
    else if(typeof dateValue.startDate === 'string' && typeof dateValue.endDate === 'string'){
      dateValue.startDate = new Date(dateValue.startDate);
      dateValue.endDate = new Date(dateValue.endDate);
    }
    else if (dateValue.endDate >= new Date()) {
      const twoDaysAgo = new Date();
      twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
      dateValue.endDate = twoDaysAgo;
    }
    dateValue.endDate.setHours(23, 59, 59, 999);
    dateValue.startDate.setHours(0, 0, 0, 0);

    this.period = dateValue
    console.log("updated period",this.period)
    if(this.googlePageIds.length>0){

      this.socialMediaService.getPageStatesProgress(this.googlePageIds, this.period).subscribe((res:any)=>{
        updateSummedMetrics(res.data.results); // Appel de la fonction pour mettre à jour summedMetrics
        this.period=res.data.period
        this.isInsightsLoading = false;
      })
      // Fonction pour mettre à jour summedMetrics sans variable intermédiaire
      const updateSummedMetrics = (dataValues: any) => {
        let i=0
        this.data.map((metric: any) => {
          const metricKey = metric.label.split('.').pop(); // Ex: "bookings" de "insights.bookings"
          // Sommer la métrique correspondante pour toutes les pages
          const total = dataValues.reduce((sum: any, item: any) => {
            return sum + (item.metrics[metricKey] || 0);
          }, 0);
          this.data[i].value = total;
          switch (metricKey) {
            case "googleMapsSearchDesktop":
              this.googleMapsSearchDesktop.value = this.data[i].value;break;
            case "googleMapsSearchMobile":
              this.googleMapsSearchMobile.value = this.data[i].value;break;
            case "googleSearchDesktop":
              this.googleSearchDesktop.value = this.data[i].value;break;
            case "googleSearchMobile":
              this.googleSearchMobile.value = this.data[i].value;break;
            case "viewsEstablishmentProfile":
              this.viewsEstablishmentProfile.value = this.data[i].value;break;
          }
          i += 1;
        });
      };
      console.log("end of update States",dateValue,this.period)
      this.uiStateService.pageStatsupdateDateRange(this.period);
    }
  }
AllGrouPages:any[]=[]
  ngOnInit(){
    const lsData = this.postService.getGroupScopesFromLocalStorage();
    this.isInsightsLoading = true;
    this.subscriptions.push(
      this.postService.currentGroups.subscribe((g: number[]) => {
        if (g.length == 0)
          g = this.postService.getGroupScopesFromLocalStorage();
        
        if (g.length > 0) {
          this.groupService.getGroupByIds(g).subscribe((res: IResponse) => {
            this.isInsightsLoading = true;
            this.AllGrouPages =this.getRecursiveSocialMediaPages(res.data)
            this.googlePageIds = this.AllGrouPages.filter((sm:any)=>sm.source=="google").map((lp:any)=>lp.id)||[];
            this.googlePageNames =this.AllGrouPages.filter((sm:any)=>sm.source=="google").map((lp:any)=> {return {id:lp.id,name:lp.name,url:lp.url}});
            this.isInsightsLoading = this.googlePageIds.length>0
            if(this.googlePageIds.length>0  ){
              this.updateStats(this.period);
            }
          });
        }
      })
    );
  }

  getRecursiveSocialMediaPages(groups: any[]): any[] {
    groups = !Array.isArray(groups) ? [groups] : groups;
    let socialMediaPages: any[] = [];
    groups.forEach((group: any) => {
      // Add the group's social media pages if any
      if (group.socialMedia && group.socialMedia.length > 0) {
        socialMediaPages = [...socialMediaPages, ...group.socialMedia];
      }

      // Recursively add social media pages from children
      if (group.children && group.children.length > 0) {
        for (let child of group.children) {
          socialMediaPages = [
            ...socialMediaPages,
            ...this.getRecursiveSocialMediaPages(child),
          ];
        }
      }
    });
    //removing any duplicates
    const pagesArrayString: string[] = socialMediaPages.map((sm: any) =>
      JSON.stringify(sm)
    );
    const uniquePagesArrayString = [...new Set(pagesArrayString)];
    this.socialMedias = uniquePagesArrayString.map((sm: any) =>
      JSON.parse(sm)
    );
    return uniquePagesArrayString.map((sm: any) => JSON.parse(sm));
  }

  gVal(data: any){
    return data && Number(data)? Number(data): 0
  }
  // delete this part 
  isPlanned: boolean = true; 
  isPost: boolean = true; 
  isDraft: boolean = true; 

  togglePost() {
    this.isPost = !this.isPost;
  }
  togglePlanned() {
    this.isPlanned = !this.isPlanned;
  }
  // end delete
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  GetGeneralData(){
    return this.data.filter((item:any)=>this.generalInsightsLabels.includes(item.label))
  }
  
  GetCommercialEngagementData(){
    return this.data.filter((item:any)=>this.commercialEngagementInsightsLabels.includes(item.label))
  }
}
